// Shared core contracts. Time is ALWAYS UNIX epoch SECONDS, UTC.

export type Timeframe = 'm1' | 'm5' | 'm15' | 'h1' | 'h4' | 'd1'

/** One OHLCV bar. `time` = UTC epoch seconds (integer), strictly ascending across a dataset. */
export interface Bar {
  time: number
  open: number
  high: number
  low: number
  close: number
  volume: number
}

export const TF_SECONDS: Record<Timeframe, number> = {
  m1: 60,
  m5: 300,
  m15: 900,
  h1: 3_600,
  h4: 14_400,
  d1: 86_400,
}

export const TF_LABEL: Record<Timeframe, string> = {
  m1: '1m',
  m5: '5m',
  m15: '15m',
  h1: '1H',
  h4: '4H',
  d1: '1D',
}
